import { Phone } from "../../src/components/phoneUI/PhoneClass";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { mc } from "../characters/MC";
import { annImages } from "../helpers/annInstaImages";
import { doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V7AnnPureOrHateAfter } from "./V7";

export const V7AnnPureOrHate = async (): Promise<any> => {
    doWaitImageByTime(images.v1.Room2);
    if (mc.properties.annStatus === "gf") {
        mc.think(`I'm awake, might as well ask Ann what she is doing...`);
        return jump(V7AnnPure, "V7AnnPure");

    } else {

    }

    return jump(V7AnnPureOrHateAfter, "V7AnnPureOrHateAfter");
};

export const V7AnnPure = async (): Promise<any> => {
    await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann2 }, async () => {
        Phone.setMessage({ character: mc.character, text: `Hey Ann! What's up?`, options: { wait: false } });
        Phone.setMessage({ character: ann.character, text: `Not much... Studying all day...`, options: { wait: false } });
        Phone.setMessage({ character: ann.character, text: `What have you been up to today?` });
        Phone.setMessage({ character: mc.character, text: `Nothing, I just woke up.` });
        Phone.setMessage({ character: ann.character, text: `Hehe, I wish I could sleep this late.` });
        Phone.setMessage({ character: mc.character, text: `There is nothing stopping you...` });
        Phone.setMessage({ character: ann.character, text: `Yeah... But there are a lot of subjects I haven't even touched yet.` });
        Phone.setMessage({ character: mc.character, text: `What's the rush?` });
        Phone.setMessage({ character: ann.character, text: `No rush...` });
        Phone.setMessage({ character: ann.character, text: `In fact... There is...` });
        Phone.setMessage({ character: mc.character, text: `I don't think I understand.` });
        Phone.setMessage({ character: ann.character, text: `I'd rather talk about it in person.` });
        Phone.setMessage({ character: mc.character, text: `I can come over right now.` });
        Phone.setMessage({ character: ann.character, text: `Maybe tomorrow?` });
        Phone.setMessage({ character: mc.character, text: `Sure, I won't force myself on you.` });
        Phone.setMessage({ character: ann.character, text: `You aren't! The pressure of trying to catch up must be getting to me.` });
        Phone.setMessage({ character: mc.character, text: `That's fine, I'll wait.` });
        Phone.setMessage({ character: ann.character, text: `Thank you! I'll make it up to you! 😘` });

        Phone.closeMessagesUI();
    });

    return jump(V7AnnPureOrHateAfter, "V7AnnPureOrHateAfter");
};